import { Box, Container } from '@mui/material'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useAdminStore } from '../../AppProvider'
import { RolesHeader } from './components/molecules/RolesHeader'
import { RolesTable } from './components/organisms/RolesTable'

export const RolesPage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { roleStore } = useAdminStore()

    const { loading } = useAsyncFetch(async () => await roleStore.load(), [roleStore])

    if (loading) return <Loader show />

    return (
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100%' }}>
        <RolesHeader />
        <Container sx={{ paddingY: theme.customSpacing.m }} data-cy='roles-table'>
          <RolesTable store={roleStore} />
        </Container>
      </Box>
    )
  }),
)
